function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { RawMarkupComponent } from '../components/base';
import EditIcon from './edit-icon';
import { MediaManagerController } from './media-manager';
import { ContentRichEditor, MinimalRichEditor, TinyEditable } from './editor';
import { PageBaseComponent } from './page-components';
import JsUtility from '../utils/utility';
import Console from '../console';
import { ScrollComponent } from '../components/components'; ////h2 title content editable

export class HeroTitle extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);else this.title.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.title.innerHTML);
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("h2", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    } else {
      return /*#__PURE__*/React.createElement("h2", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    }
  }

} ////h2 title text content editable

export class H2Title extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);else this.title.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.title.innerHTML);
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("h2", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    } else {
      return /*#__PURE__*/React.createElement("h2", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    }
  }

} ////h3 title content editable

export class H3Title extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);else this.title.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.title.innerHTML);
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("h3", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    } else {
      return /*#__PURE__*/React.createElement("h3", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    }
  }

} ///h4 title content editable

export class H4Title extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);else this.title.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.title.innerHTML);
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("h4", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    } else {
      return /*#__PURE__*/React.createElement("h4", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    }
  }

} ///h5 title content editable

export class H5Title extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);else this.title.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.title.innerHTML);
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("h5", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    } else {
      return /*#__PURE__*/React.createElement("h5", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    }
  }

}
export class H1Title extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.title.setAttribute('contenteditable', true);else this.title.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.title.innerHTML);
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("h1", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    } else {
      return /*#__PURE__*/React.createElement("h1", {
        className: this.props.cls,
        ref: ref => this.title = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.title)
      });
    }
  }

} ///h5 title content editable

export class BlockQuotation extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.quote.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.quote.setAttribute('contenteditable', true);else this.quote.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.quote.innerHTML);
  }

  getContent() {
    return this.quote.innerHTML;
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("blockquote", {
        className: this.props.cls,
        ref: ref => this.quote = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.quote)
      });
    } else {
      return /*#__PURE__*/React.createElement("blockquote", {
        className: this.props.cls,
        ref: ref => this.quote = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.quote)
      });
    }
  }

} ///unordered list content editable

export class ListEditor extends RawMarkupComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.active) this.list.setAttribute('contenteditable', true);
  }

  componentDidUpdate() {
    if (this.props.active) this.list.setAttribute('contenteditable', true);else this.list.removeAttribute('contenteditable');
  }

  onChange(event) {
    if (this.props.onChange) this.props.onChange(this.list.innerHTML);
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement("ul", {
        className: this.props.cls,
        ref: ref => this.list = ref,
        onBlur: this.onChange.bind(this),
        dangerouslySetInnerHTML: this.rawMarkup(this.props.items)
      });
    } else {
      return /*#__PURE__*/React.createElement("ul", {
        className: this.props.cls,
        ref: ref => this.list = ref,
        dangerouslySetInnerHTML: this.rawMarkup(this.props.items)
      });
    }
  }

} ///linkable image

export class ImageLink extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  onFilesCancel() {}

  onClick(event) {
    var link = this.props.media.link;
    var newTarget = this.props.media.newTarget;

    if (link && newTarget) {
      window.open(link);
    } else {
      location.href = link;
    }
  }

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.props.media]);
  }

  render() {
    var src = this.props.media.url;
    if (this.props.width) src += '?width=' + this.props.width;
    var cls = 'relative';
    if (this.props.cls) cls += ' ' + this.props.cls;
    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      onClick: this.onClick.bind(this)
    }), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.props.active
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.props.onFilesSelected,
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class Image extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  onFilesCancel() {}

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.props.media]);
  }

  get Image() {
    return this.image;
  }

  render() {
    var src = this.props.media.url;
    if (this.props.width) src += '?width=' + this.props.width;
    var cls = 'relative';
    if (this.props.cls) cls += ' ' + this.props.cls;
    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    var imgCss = this.props.imgCss;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      className: imgCss,
      ref: ref => this.image = ref
    }), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.props.active
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.props.onFilesSelected,
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class MultiSlideCarousel extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    var cls = this.props.cls;
    if (!cls) cls = '';
    var width = '23000px';

    if (this.props.width) {
      width = `${this.props.width}px`;
    }

    var style = {
      width: width
    };
    return /*#__PURE__*/React.createElement("ui-carousel", {
      animation: "multi-slide",
      class: cls
    }, /*#__PURE__*/React.createElement("carousel-navigation", {
      class: "prev disabled"
    }), /*#__PURE__*/React.createElement("carousel-navigation", {
      class: "next nav-visible"
    }), /*#__PURE__*/React.createElement("carousel-navigation", {
      class: "indicators"
    }), /*#__PURE__*/React.createElement("carousel-inner-container", {
      class: "visible multi-border"
    }, /*#__PURE__*/React.createElement("carousel-items", {
      style: style
    }, this.props.children)));
  }

}
export class HeaderTitleComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement("header", {
      className: cls
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this)
    }));
  }

}
export class HeroTitleComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(HeroTitle, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this),
      cls: cls
    });
  }

}
export class H3TitleComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this),
      cls: cls
    });
  }

}
export class H4TitleComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(H4Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this),
      cls: cls
    });
  }

}
export class H5TitleComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(H5Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this),
      cls: cls
    });
  }

}
export class HeroComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onFilesSelected(files) {
    this.state.component.content.media = files[0];
    this.setState(this.state.component);
  }

  onFilesCancel() {}

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.state.component.content.media]);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  render() {
    var src = this.state.component.content.media.url;
    src += '?width=1600';
    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("section", {
      className: "image-stretch-container"
    }, /*#__PURE__*/React.createElement("img", {
      src: src
    }), /*#__PURE__*/React.createElement(HeroTitle, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this),
      cls: this.props.cssClass
    }), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected.bind(this),
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class HeroPictureComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onFilesSelected(files) {
    this.state.component.content.media = files[0];
    this.setState(this.state.component);
  }

  onFilesCancel() {}

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.state.component.content.media]);
  }

  render() {
    var src = this.state.component.content.media.url;
    var mobileSrc = JsUtility.toMobileUrl(src);
    var cls = 'image-stretch-container';

    if (this.props.cssClass) {
      cls += ' ' + this.props.cssClass;
    }

    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("section", {
      className: cls
    }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 641px)",
      srcSet: src
    }), /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 640px)",
      srcSet: mobileSrc
    }), /*#__PURE__*/React.createElement("img", {
      src: src
    })), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected.bind(this),
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class HeroPictureTitleComponent extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onFilesSelected", files => {
      this.state.component.content.media = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFilesCancel", () => {});

    _defineProperty(this, "onEditClick", event => {
      this.mediaController.mode = 'select';
      this.mediaController.show([this.state.component.content.media]);
    });

    _defineProperty(this, "onTitleChange", title => {
      this.state.component.content.title = title;
      this.setState(this.state.component);
    });
  }

  componentDidMount() {
    super.componentDidMount();
  }

  render() {
    var src = this.state.component.content.media.url;
    var mobileSrc = JsUtility.toMobileUrl(src);
    src += '?width=1920';
    mobileSrc += '?width=640';
    var cls = 'image-stretch-container';

    if (this.props.cssClass) {
      cls += ' ' + this.props.cssClass;
    }

    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("section", {
      className: cls
    }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 641px)",
      srcSet: src
    }), /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 640px)",
      srcSet: mobileSrc
    }), /*#__PURE__*/React.createElement("img", {
      src: src
    })), /*#__PURE__*/React.createElement(HeroTitle, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange,
      cls: this.props.cssClass
    }), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick,
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected,
      onCancel: this.onFilesCancel
    })));
  }

}
export class HeroImageComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onFilesSelected(files) {
    this.state.component.content.media = files[0];
    this.setState(this.state.component);
  }

  onFilesCancel() {}

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.state.component.content.media]);
  }

  render() {
    var src = this.state.component.content.media.url;
    var cls = 'image-stretch-container';

    if (this.props.css) {
      cls += ' ' + this.props.cssClass;
    }

    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("section", {
      className: cls
    }, /*#__PURE__*/React.createElement("img", {
      src: src
    }), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected.bind(this),
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class HeroPictureLinkComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onFilesSelected(files) {
    this.state.component.content.media = files[0];
    this.setState(this.state.component);
  }

  onFilesCancel() {}

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.state.component.content.media]);
  }

  onClick(event) {
    var link = this.state.component.content.media.link;
    var newTarget = this.state.component.content.media.newTarget;

    if (link && newTarget) {
      window.open(link);
    } else {
      location.href = link;
    }
  }

  render() {
    var src = this.state.component.content.media.url;
    var mobileSrc = JsUtility.toMobileUrl(src);
    var cls = 'image-stretch-container pointer';

    if (this.props.cssClass) {
      cls += ' ' + this.props.css;
    }

    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("section", {
      className: cls,
      onClick: this.onClick.bind(this)
    }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 641px)",
      srcSet: src
    }), /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 640px)",
      srcSet: mobileSrc
    }), /*#__PURE__*/React.createElement("img", {
      src: src
    })), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected.bind(this),
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class HeroImageLinkComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onFilesSelected(files) {
    this.state.component.content.media = files[0];
    this.setState(this.state.component);
  }

  onFilesCancel() {}

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.state.component.content.media]);
  }

  onClick(event) {
    var link = this.state.component.content.media.link;
    var newTarget = this.state.component.content.media.newTarget;

    if (link && newTarget) {
      window.open(link);
    } else {
      location.href = link;
    }
  }

  render() {
    var src = this.state.component.content.media.url;
    var cls = 'image-stretch-container pointer';

    if (this.props.cssClass) {
      cls += ' ' + this.props.css;
    }

    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("section", {
      className: cls,
      onClick: this.onClick.bind(this)
    }, /*#__PURE__*/React.createElement("img", {
      src: src
    }), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected.bind(this),
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class ImageComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onFilesSelected(files) {
    this.state.component.content.media = files[0];
    this.setState(this.state.component);
  }

  onFilesCancel() {}

  onClick(event) {
    var link = this.state.component.content.media.link;
    var newTarget = this.state.component.content.media.newTarget;
    if (link && newTarget) window.open(link);else if (link) location.href = link;
  }

  onEditClick(event) {
    this.mediaController.mode = 'select';
    this.mediaController.show([this.state.component.content.media]);
  }

  render() {
    var src = this.state.component.content.media.url;
    var link = this.state.component.content.media.link;
    var imgCls = '';
    if (link) imgCls = 'pointer';
    if (this.props.width) src += '?width=' + this.props.width;
    var cls = 'relative';
    if (this.props.cssClass) cls += ' ' + this.props.cssClass;
    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      onClick: this.onClick.bind(this),
      className: imgCls
    }), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected.bind(this),
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export class HtmlEditorComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onEditorChange(html) {
    this.state.component.content.body = html;
    this.setState(this.state.component);
  }

  onGetContent(data) {
    data.content.body = this.editor.getContent();
    return data;
  }

  render() {
    var cls = this.props.cssClass;
    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement(ContentRichEditor, {
      filePostUrl: postUrl,
      content: this.state.component.content.body,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      ref: ref => this.editor = ref,
      cls: cls
    });
  }

}
export class HeaderListComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  onEditorChange(items) {
    this.state.component.content.items = items;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(H4Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this)
    }), /*#__PURE__*/React.createElement(ListEditor, {
      active: this.state.component.active,
      items: this.state.component.content.items,
      onChange: this.onEditorChange.bind(this),
      cls: this.props.cssClass
    }));
  }

}
export class HeroTitleListComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  onEditorChange(items) {
    this.state.component.content.items = items;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(H2Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this)
    }), /*#__PURE__*/React.createElement(ListEditor, {
      active: this.state.component.active,
      items: this.state.component.content.items,
      onChange: this.onEditorChange.bind(this),
      cls: this.props.listCssClass
    }));
  }

}
export class EditorListComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onEditorChange(items) {
    this.state.component.content.items = items;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(ListEditor, {
      active: this.state.component.active,
      items: this.state.component.content.items,
      onChange: this.onEditorChange.bind(this),
      cls: this.props.cssClass
    });
  }

}
export class TinyEditorComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onGetContent(data) {
    var content = this.editor.getContent();
    if (!data.content) data.content = {};
    data.content.html = content;
    return data;
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(TinyRichEditor, {
      addColors: "#a6978a",
      content: this.state.component.content.html,
      active: this.state.component.active,
      cls: cls,
      disableSticky: true,
      ref: ref => this.editor = ref
    });
  }

}
export class MinimalEditorComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onGetContent(data) {
    var content = this.editor.getContent();
    if (!data.content) data.content = {};
    data.content.html = content;
    return data;
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(MinimalRichEditor, {
      content: this.state.component.content.html,
      active: this.state.component.active,
      disableSticky: true,
      cls: cls,
      ref: ref => this.editor = ref
    });
  }

}
export class ContentEditableComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onGetContent(data) {
    data.content.html = this.editor.getContent();
    return data;
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement(TinyEditable, {
      content: this.state.component.content.html,
      active: this.state.component.active,
      cls: cls,
      ref: ref => this.editor = ref
    });
  }

}
export class TitleContentEditableComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  onEditorChange(html) {
    this.state.component.content.html = html;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(H2Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this)
    }), /*#__PURE__*/React.createElement(TinyEditable, {
      active: this.state.component.active,
      content: this.state.component.content.html,
      onChange: this.onEditorChange.bind(this),
      cls: this.props.editorCss
    }));
  }

}
export class TitleTinyEditorComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  onGetContent(data) {
    data.content.html = this.editor.getContent();
    return data;
  }

  render() {
    var cls = this.props.cssClass;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(H2Title, {
      active: this.state.component.active,
      title: this.state.component.content.title,
      onChange: this.onTitleChange.bind(this)
    }), /*#__PURE__*/React.createElement(TinyRichEditor, {
      addColors: "#a6978a",
      content: this.state.component.content.html,
      active: this.state.component.active,
      cls: cls,
      disableSticky: true,
      ref: ref => this.editor = ref
    }));
  }

}
export class BlockQuoteComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onQuoteChange(quote) {
    this.state.component.content = quote;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    console.log(this.state.component.content);
    return /*#__PURE__*/React.createElement(BlockQuotation, {
      active: this.state.component.active,
      quote: this.state.component.content,
      onChange: this.onQuoteChange.bind(this),
      cls: cls
    });
  }

}
export class HTitleComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  onTitleChange(title) {
    this.state.component.content.title = title;
    this.setState(this.state.component);
  }

  render() {
    var cls = this.props.cssClass;
    var type = this.props.type;

    if (!type) {
      type = 'h2';
    }

    if (type === 'h5') {
      return /*#__PURE__*/React.createElement(H5Title, {
        active: this.state.component.active,
        title: this.state.component.content.title,
        onChange: this.onTitleChange.bind(this),
        cls: cls
      });
    } else if (type === 'h4') {
      return /*#__PURE__*/React.createElement(H4Title, {
        active: this.state.component.active,
        title: this.state.component.content.title,
        onChange: this.onTitleChange.bind(this),
        cls: cls
      });
    } else if (type === 'h3') {
      return /*#__PURE__*/React.createElement(H3Title, {
        active: this.state.component.active,
        title: this.state.component.content.title,
        onChange: this.onTitleChange.bind(this),
        cls: cls
      });
    } else if (type === 'h2') {
      return /*#__PURE__*/React.createElement(H2Title, {
        active: this.state.component.active,
        title: this.state.component.content.title,
        onChange: this.onTitleChange.bind(this),
        cls: cls
      });
    } else if (type === 'h1') {
      return /*#__PURE__*/React.createElement(H1Title, {
        active: this.state.component.active,
        title: this.state.component.content.title,
        onChange: this.onTitleChange.bind(this),
        cls: cls
      });
    } else {
      return /*#__PURE__*/React.createElement(H2Title, {
        active: this.state.component.active,
        title: this.state.component.content.title,
        onChange: this.onTitleChange.bind(this),
        cls: cls
      });
    }
  }

}
export class DownArrow extends ScrollComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onScroll", y => {
      this.props.onScroll(y);
    });
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "down-arrow-container",
      onClick: this.props.onClick
    }, /*#__PURE__*/React.createElement("img", {
      src: "/icons/down-arrow.svg"
    }));
  }

}
export class VideoComponent extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "setNativeVideoControls", () => {
      if (this.isTouch) {
        var video = this.video;
        video.setAttribute("controls", "controls");
      }
    });

    _defineProperty(this, "onEditClick", event => {
      this.mediaController.mode = 'select';
      this.mediaController.show([this.state.component.content.media]);
    });

    _defineProperty(this, "onFilesSelected", files => {
      this.state.component.content.media = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFilesCancel", () => {});

    _defineProperty(this, "onSound", event => {
      var video = this.video;
      video.muted = !video.muted;
      this.icons.mute = null;
      this.icons.sound = 'hide';
      this.mute.classList.remove('hide');
      this.sound.classList.add('hide');
    });

    _defineProperty(this, "onMute", event => {
      var video = this.video;
      video.muted = !video.muted;
      this.icons.mute = 'hide';
      this.icons.sound = null;
      this.mute.classList.add('hide');
      this.sound.classList.remove('hide');
    });

    _defineProperty(this, "onPlay", event => {
      var video = this.video;
      video.play();
      this.play.classList.add('hide');
      this.pause.classList.remove('hide');
      this.icons.pause = null;
      this.icons.play = 'hide';
    });

    _defineProperty(this, "onPause", event => {
      var video = this.video;
      video.pause();
      this.play.classList.remove('hide');
      this.pause.classList.add('hide');
      this.icons.pause = 'hide';
      this.icons.play = null;
    });

    this.icons = {
      sound: 'hide',
      mute: null,
      play: 'hide',
      pause: null
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.setNativeVideoControls();
    this.video.play();
  }

  componentDidUpdate() {
    if (this.state.component.active) {
      var video = this.video;
      video.pause();
      this.play.classList.remove('hide');
      this.pause.classList.add('hide');
      this.icons.pause = 'hide';
      this.icons.play = null;
    }
  }

  render() {
    var cls = 'relative';
    if (this.props.cssClass) cls += ' ' + this.props.cssClass;
    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    var src = this.state.component.content.media.url;
    var mIconClass = 'material-icons large-icon';
    var soundIconClass = mIconClass;
    var muteIconClass = mIconClass;
    var playIconClass = mIconClass;
    var pauseIconClass = mIconClass;
    var icons = this.icons;

    if (icons.sound) {
      soundIconClass += ' hide';
    }

    if (icons.mute) {
      muteIconClass += ' hide';
    }

    if (icons.play) {
      playIconClass += ' hide';
    }

    if (icons.pause) {
      pauseIconClass += ' hide';
    }

    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("video", {
      muted: true,
      loop: true,
      ref: ref => this.video = ref
    }, /*#__PURE__*/React.createElement("source", {
      src: src,
      type: "video/mp4"
    })), /*#__PURE__*/React.createElement("div", {
      className: "component-video-controls"
    }, /*#__PURE__*/React.createElement("span", {
      className: soundIconClass,
      ref: ref => this.sound = ref,
      onClick: this.onSound
    }, "volume_mute"), /*#__PURE__*/React.createElement("span", {
      className: muteIconClass,
      ref: ref => this.mute = ref,
      onClick: this.onMute
    }, "volume_off"), /*#__PURE__*/React.createElement("span", {
      className: playIconClass,
      ref: ref => this.play = ref,
      onClick: this.onPlay
    }, "play_arrow"), /*#__PURE__*/React.createElement("span", {
      className: pauseIconClass,
      ref: ref => this.pause = ref,
      onClick: this.onPause
    }, "pause")), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick,
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected,
      onCancel: this.onFilesCancel
    })));
  }

}
export class MultiSlideCarouselComponent extends PageBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onFilesSelected(files) {
    this.state.component.content.media = files;
    this.setState(this.state.component);
  }

  onFilesCancel() {}

  onEditClick(event) {
    this.mediaController.mode = 'multi-select';
    this.mediaController.show(this.state.component.content.media);
  }

  getNodes() {}

  render() {
    var nodes = this.getNodes();
    return /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement(MultiSlideCarousel, {
      cls: this.cls
    }, nodes), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick.bind(this),
      active: this.state.component.active
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: "/api/MediaFile",
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected.bind(this),
      onCancel: this.onFilesCancel.bind(this)
    })));
  }

}
export default {
  HeroTitle,
  H2Title,
  H3Title,
  H4Title,
  H5Title,
  H1Title,
  BlockQuotation,
  ListEditor,
  ImageLink,
  Image,
  HeaderTitleComponent,
  HeroTitleComponent,
  H3TitleComponent,
  H4TitleComponent,
  H5TitleComponent,
  HTitleComponent,
  HeroComponent,
  HeroPictureComponent,
  HeroPictureTitleComponent,
  HeroImageComponent,
  HeroPictureLinkComponent,
  HeroImageLinkComponent,
  ImageComponent,
  HtmlEditorComponent,
  HeaderListComponent,
  HeroTitleListComponent,
  EditorListComponent,
  TinyEditorComponent,
  MinimalEditorComponent,
  ContentEditableComponent,
  TitleContentEditableComponent,
  TitleTinyEditorComponent,
  BlockQuoteComponent,
  DownArrow,
  VideoComponent,
  MultiSlideCarouselComponent
};